import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Box } from '@mui/material';
import { useTranslations } from 'next-intl';
import LazyImage from '../components/LazyImage';
import { useUser } from '@hooks/useUser';

interface RegisterCryptoMagnetDialogProps {
  onClose: () => void;
  openDialog: boolean;
}

export const RegisterCryptoMagnetDialog = ({ openDialog, onClose }: RegisterCryptoMagnetDialogProps) => {
  const t = useTranslations();
  const user = useUser();

  return (
    <Dialog aria-labelledby='entrance-dialog' open={openDialog} maxWidth='sm' fullWidth scroll='body' onClose={onClose}>
      <DialogTitle sx={{ background: '#1C1929', position: 'relative' }}>
        <Typography
          variant='h5'
          sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center', letterSpacing: '1.5px', px: 4 }}
        >
          {t('common.registrationInCryptoMagnet')}!
        </Typography>
        <Box sx={{ position: 'absolute', top: 20, right: 24, cursor: 'pointer' }} onClick={onClose}>
          <LazyImage src={'/images/icons/landing/close.svg'} alt='close' width={24} height={24} />
        </Box>
      </DialogTitle>
      <DialogContent sx={{ background: '#1C1929' }}>
        <DialogContent sx={{ position: 'relative', background: '#1C1929', p: 0 }}>
          <Typography style={{ color: 'white', opacity: 0.6 }} variant='body1' sx={{ textAlign: 'center' }}>
            {t('common.registrationInCryptoMagnetInfo')}
          </Typography>
        </DialogContent>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', p: 0, pb: '20px', background: '#1C1929' }}>
        <a
          href={process.env.NEXT_PUBLIC_CRYPTO_MAGNET_URL + '/?start=linkMagnetAccount_' + btoa(String(user?.id))}
          target='_blank'
        >
          <Button
            sx={{
              color: 'white',
              cursor: 'pointer',
              padding: '5px 15px',
              borderRadius: 15,
              background: '#ffffff1A'
            }}
          >
            {t('common.registerCryptoMagnetBtn')}
          </Button>
        </a>
      </DialogActions>
    </Dialog>
  );
};
